import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import UiButton from 'ui-components/ui-button/UiButton';
import UiTableDeleteOptionModal from 'ui-components/ui-table/ui-table-delete-option-modal/UiTableDeleteOptionModal';
import { StyledUiToolbar } from './UiToolbar.styles';

const UiToolbar = (props) => {
  const {
    selected = [],
    title = '',
    actions = [],
    updateData,
    onRemoveSelected,
    content,
    unVisibleCloseBtn,
    titleClassName,
    className,
    'data-testid': dataTestId,
  } = props;
  const { t } = useTranslation();

  return (
    <StyledUiToolbar>
      <div className={classNames('ui-toolbar flex', className)}>
        {!unVisibleCloseBtn && (
          <div className='close-container'>
            <div className='icon-close flex' onClick={onRemoveSelected}>
              <UiIcon
                icon='ri-close-line'
                color='#F5F5F5'
                hover='#F5F5F5'
                data-testid={`${dataTestId}-close`}
              />
            </div>
          </div>
        )}
        <div
          className={`main-container ${
            unVisibleCloseBtn ? 'close-not-exists' : ''
          }`}
        >
          <div className={`title ${titleClassName}`}>
            {!content
              ? t('common:selectedItemsCount', {
                  title,
                  count: selected?.length,
                })
              : content}
            {!content && (
              <span className='hide-in-mobile-size'>
                {t('common:selectYourOperation')}
              </span>
            )}
          </div>
        </div>
        <div className='actions-container flex'>
          {actions?.map((action, index) => (
            <React.Fragment key={action?.key || index}>
              {action?.render
                ? action?.render(action, updateData, selected)
                : action?.key === 'delete-toolbar' && (
                    <UiTableDeleteOptionModal
                      className='action'
                      action={action}
                      updateData={updateData}
                      selected={selected}
                      data-testid={`${dataTestId}-delete`}
                    >
                      <UiButton
                        variant='contained'
                        color='secondary'
                        startIcon={
                          action?.iconSrc && (
                            <UiIcon icon={action?.iconSrc} color='#FFFFFF' />
                          )
                        }
                        data-testid={`${dataTestId}-delete-btn`}
                      >
                        {action?.title} {t('common:plural')}
                      </UiButton>
                    </UiTableDeleteOptionModal>
                  )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </StyledUiToolbar>
  );
};

UiToolbar.propTypes = {
  selected: PropTypes.array,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  actions: PropTypes.array,
  updateData: PropTypes.func,
  onRemoveSelected: PropTypes.func, //پاک کردن همه انتخاب شده ها
  content: PropTypes.func,
  unVisibleCloseBtn: PropTypes.bool,
  'data-testid': PropTypes.string,
  className: PropTypes.string,
};

export default memo(UiToolbar);
